export const UPGRADE_ORDER_UNAUTHORIZED_MESSAGE =
  'You are not authorised to modify this account. Please sign in with the correct Sky TV account and try again.';

export class UpgradeOrderAuthorizationError extends Error {
  constructor() {
    super(UPGRADE_ORDER_UNAUTHORIZED_MESSAGE);
    this.name = 'UpgradeOrderAuthorizationError';
  }
}

const normalizeAccountNumber = (accountNumber?: string | null) => accountNumber?.trim() ?? '';

export const assertUpgradeOrderAccountOwnership = (
  authenticatedAccountNumber?: string | null,
  targetAccountNumber?: string | null
) => {
  const authenticated = normalizeAccountNumber(authenticatedAccountNumber);
  const target = normalizeAccountNumber(targetAccountNumber);

  if (!authenticated || !target || authenticated !== target) {
    throw new UpgradeOrderAuthorizationError();
  }
};
